import { LoginCard } from "@/components/LoginModal/loginView";
import useAppStore from "@/context/store";
import { AuthBgWrap } from "@/pageComponents/PageBg";
import { MSG_TYPE, postMessageToParent } from "@/utils/postMessageToParent";
import { isWhiteListRedirectUrl } from "@/utils/safeRedirectUrl";
import { useMemoizedFn } from "ahooks";
import Head from "next/head";
import { useRouter } from "next/router";
import { useEffect } from "react";

export default function Login() {
  const router = useRouter();
  const { defaultType, defaultTel } = router.query;

  const { user, userReady } = useAppStore(({ user, userReady }) => ({
    user,
    userReady,
  }));

  const onLogin = useMemoizedFn(async () => {
    // 通知父窗口登录成功
    postMessageToParent(MSG_TYPE.loginResult, {
      message: "Ok",
    });

    if (router.query.dialog === "1") {
      window.close();
    }
  });

  useEffect(() => {
    if (userReady && user) {
      let targetUrl = router.query.next || router.query.redirect_uri;

      if (targetUrl) {
        const urlObj = new URL(targetUrl, "https://huaban.com");

        // 自定义协议host会为空字符串 && 不匹配白名单
        if (urlObj.host !== "" && !isWhiteListRedirectUrl(urlObj.host)) {
          targetUrl = "/";
        }

        router.push(targetUrl);
      } else {
        if (router.query.from) {
          // 由其他窗口打开的页面，不做页面跳转
          return;
        }
        router.push("/follow");
      }
    }
  }, [router, user, userReady]);

  return (
    <AuthBgWrap noLogo={router.query?.noLogo}>
      <Head>
        <title>登录注册_花瓣网</title>
      </Head>
      <LoginCard
        onOk={onLogin}
        initType={defaultType}
        initialTel={defaultTel}
      />
    </AuthBgWrap>
  );
}
